import type { RouteObject } from 'react-router-dom';
import { LegacyRedirect } from './LegacyRedirect';

/**
 * Old paths, kept working for a while.
 *
 * Every module's pages moved under its own prefix (`/patients` →
 * `/clinic/patients`), which is what lets the shell derive the active module
 * from the URL. Nothing external points at a dashboard path — the QR on a
 * printed prescription carries the bare token, and a notification row stores an
 * entity, not a URL — so this table exists for two human reasons: bookmarks and
 * browser history, and links colleagues paste to each other in WhatsApp, which
 * is how this team shares a record. A bookmarked `/patients` landing on the 404
 * page gets reported as a broken deployment and costs someone an afternoon.
 *
 * The query string and hash are carried across, because a bookmark is usually a
 * filtered list (`/licenses?reviewStatus=PENDING`).
 *
 * `/prescriptions` is deliberately **not** in the table: the pages it used to
 * point at were removed on 2026-09-28, so a bookmark to it has nowhere to land
 * and the 404 is the honest answer.
 *
 * DELETE THIS FILE AND ITS ROUTES AFTER 2026-11-30 — the release after next. A
 * redirect table with no expiry quietly becomes a second route table, which is
 * the thing this change removed.
 */
export const LEGACY_PATHS: Array<[from: string, to: string]> = [
  ['/organizations', '/directory/organizations'],
  ['/applications', '/directory/applications'],
  ['/licenses', '/directory/licenses'],
  ['/organization-types', '/reference/organization-types'],
  ['/specialties', '/reference/specialties'],
  ['/audit-log', '/reference/audit-log'],
  ['/users', '/access/users'],
  ['/roles', '/access/roles'],
  ['/deliveries', '/logistics/deliveries'],
  ['/patients', '/clinic/patients'],
  ['/visits', '/clinic/visits'],
  ['/consultation', '/clinic/consultation'],
  ['/doctors', '/clinic/doctors'],
];

/** One splat route per entry: `x/*` matches `/x` and everything under it. */
export function legacyRedirects(): RouteObject[] {
  return LEGACY_PATHS.map(([from, to]) => ({
    path: `${from}/*`,
    element: <LegacyRedirect to={to} />,
  }));
}
